import { createContext, useContext, useLayoutEffect, type Dispatch, type SetStateAction } from "react";

export const LayoutTitleContext = createContext<Dispatch<SetStateAction<string>> | null>(null);

export function useLayoutTitle(title: string) {
  const setTitle = useContext(LayoutTitleContext);

  if (!setTitle) {
    throw new Error("useLayoutTitle must be used inside LayoutTitleContext.Provider");
  }

  useLayoutEffect(() => {
    setTitle(title);

    return () => {
      setTitle("");
    };
  }, [setTitle, title]);
}
